<template>
  <ankh-list :showBtnGroup="false" :showSearchForm="false">
    <template #table="{height}">
      <fans-record :height="height" />
    </template>
  </ankh-list>
</template>

<script>
import FansRecord from "@/components/user/FansRecord";
import AnkhList from "@/components/list/AnkhList.vue";
export default {
  name: "UserFans",
  components: {AnkhList, FansRecord}
}
</script>

<style scoped>

</style>
